import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PlaybookCommunicationService } from 'src/app/playbook-editor/shared/services/playbook-communication.service';
import { UtilService } from 'src/app/playbook-editor/shared/services/utils/util.service';
import { Playbook } from 'src/app/shared/model/playbook.models';
import { CommonHttpService } from 'src/app/shared/services/common-http/common-http.service';

@Component({
    selector: 'app-page-template-editor',
    templateUrl: './page-template-editor.component.html',
    styleUrls: ['./page-template-editor.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PageTemplateEditorComponent implements OnInit {

  playbook: Playbook;
  pageTemplate;
  container;
  companyId = 0;
  loaded = false;
  pageTemplateId;
  private resourceOn = false;
  private resourceOnSubscriber: Subscription;
  returnUrl = null;

  constructor(
    private commonHttpService: CommonHttpService,
    private commService: PlaybookCommunicationService,
    private router: ActivatedRoute,
    private route: Router,
    private utilService: UtilService,
  ) {
    this.returnUrl = this.route.getCurrentNavigation().extras.state ? this.route.getCurrentNavigation().extras.state['returnUrl'] : '';
    this.pageTemplateId = this.router.snapshot.params.pageTemplateId;
  }

  ngOnInit() {
    this.commonHttpService.get<any>(
      {
        uri: `/api/PageTemplates/GetPageTemplateManifest?pageTemplateId=${this.pageTemplateId}`
      }).subscribe(resp => {
        const response = JSON.parse(resp.json);
        this.playbook = response.playbook;
        this.pageTemplate = response.pageTemplate;
        this.playbook.id = null;
        this.commService.Playbook = this.playbook;
        this.container = this.playbook.containers[0];
        this.container.on = true;
        this.loaded = true;
        this.commService.setCurrentPageData = this.utilService.getCurrentPageData(this.playbook, this.container.id);
        this.companyId = this.playbook.companyId;
      })
    this.resourceOnSubscriber = this.commService.getResourcesOn().subscribe(isOn => {
      if (isOn) {
        this.resourceOn = isOn;
      } else {
        setTimeout(() => {
          this.resourceOn = isOn;
        }, 500);
      }
    });
  }

  refreshPageTemplateManifest() {
    this.loaded = false;
    this.commonHttpService.get<any>(
      {
        uri: `/api/PageTemplates/GetPageTemplateManifest?pageTemplateId=${this.pageTemplate.id}`
      })
      .subscribe(response => {
        const playbookData = (JSON.parse(response.json)).playbook;
        this.commService.Playbook = playbookData;
        this.playbook = playbookData;
        this.playbook.id = null;
        this.container = this.playbook.containers[0];
        this.container.on = true;
        this.loaded = true;
        this.commService.setCurrentPageData = this.utilService.getCurrentPageData(this.playbook, this.container.id);
      });
  }

  clearSelectedEditor(isHideContentBox) {
    this.commService.sendSelectedContentBlockId(null);
    this.commService.sendSelectedRowId(null);
    if (isHideContentBox) {
      this.commService.sendSelectedContentBox(false);
    }
  }
  ngOnDestroy() {
    if (this.resourceOnSubscriber) {
      this.resourceOnSubscriber.unsubscribe()
    }
  }
}
